import React, { useState, useRef, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from './api/client';
import * as XLSX from 'xlsx';
import HeaderLogged from './components/header_logged';
import DataTable from './components/DataTable';
import Container from './components/container';
import Tabs from './components/Tabs';
import TableTittle from './components/TableTittle';
import SearchAndFilter from './components/SearchAndFilter';
import Icons from './components/icons';
import Popup from './components/Popup';
import PopupConfirmSeeds from './components/PopupConfirmSeeds';
import { API_URL } from './config';
import { toZonedTime, format } from 'date-fns-tz';
import '@fortawesome/fontawesome-free/css/all.min.css';
import DataTableWithExpandableRows from './components/DataTableWithExpandableRows';
import SecondaryTable from './components/SecondaryTable';
import UniversalDataTable from './components/UniversalDataTable';
import FlexibleSecondaryTable from './components/FlexibleSecondaryTable';
import PopupWMProduction from './components/PopupWMProduction';
import PopupFertProduction from './components/PopupFertProduction';
import PopupKitProduction from './components/PopupKitProduction';
import PopupSetsProduction from './components/PopupSetsProduction';
import EditableUsedBagsTable from './components/EditableUsedBagsTable';

const ProductionPage = () => {
    const filtersConfig = {
        sbproduction: [],
        mbproduction: [],
    };

    const { tab: urlTab } = useParams();
    const navigate = useNavigate();

    const [filterParams, setFilterParams] = useState(() => {
        const initialFilters = {};
        for (const tab in filtersConfig) {
            filtersConfig[tab].forEach(filter => {
                if (filter.defaultValue) {
                    initialFilters[filter.field] = filter.defaultValue;
                }
            });
        }
        return initialFilters;
    });

    const handleTabChange = (newTab) => {
        setActiveTab(newTab);
        navigate(`/production/${newTab}`);
        const defaultFilters = {};
        if (filtersConfig[newTab]) {
            filtersConfig[newTab].forEach((filter) => {
                defaultFilters[filter.field] = filter.defaultValue || '';
            });
        }
        setFilterParams(defaultFilters);
    };

    const setDefaultFilters = () => {
        const defaultFilters = {};
        if (Array.isArray(filtersConfig[activeTab])) {
            filtersConfig[activeTab].forEach(filter => {
                if (filter.defaultValue) {
                    defaultFilters[filter.field] = filter.defaultValue;
                }
            });
        }
        setFilterParams(defaultFilters);
    };

    useEffect(() => {
        setDefaultFilters();
    }, []);

    const [searchTerm, setSearchTerm] = useState('');
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [popupFields, setPopupFields] = useState([]);
    const [secondPopupFields, setSecondPopupFields] = useState([]);
    const [popupTitle, setPopupTitle] = useState('');
    const [popupSubtitle, setPopupSubtitle] = useState('');
    const [updateKey, setUpdateKey] = useState(0);
    const [activeTab, setActiveTab] = useState(urlTab || 'sbproduction');
    const [data, setData] = useState([]);
    const tableRefs = useRef({});
    const [gPerPacket, setGPerPacket] = useState(0);
    // Что фасуют: 'seeds' (individualpackets) или 'fert' (пакетик удобрения, fert_products)
    const [productType, setProductType] = useState('seeds');
    const materialWord = productType === 'fert' ? 'Fertilizer' : 'Seeds';
    const [approxSeedsNeeded, setApproxSeedsNeeded] = useState(0);
    const [seedsstock, setSeedsstock] = useState(0);
    const [seedslot, setSeedslot] = useState('N/A');
    const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState(false);
    const [selectedGTIN, setSelectedGTIN] = useState('');
    const [selectedSKU, setSelectedSKU] = useState('');
    const [initialPopupData, setInitialPopupData] = useState(null);
    const [isAddMode, setIsAddMode] = useState(false);
    const [bagsTakenForProduction, setBagsTakenForProduction] = useState([]);
    const [isWMPopupOpen, setIsWMPopupOpen] = useState(false);
    const [wmPopupData, setWMPopupData] = useState(null);
    const [isFertPopupOpen, setIsFertPopupOpen] = useState(false);
    const [fertPopupData, setFertPopupData] = useState(null);
    const [isKitPopupOpen, setIsKitPopupOpen] = useState(false);
    const [kitPopupData,   setKitPopupData]   = useState(null);
    const [isSetsPopupOpen, setIsSetsPopupOpen] = useState(false);
    const userLocalDate = new Date();
    const utcDate = userLocalDate.toISOString().split('T')[0];
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const [usedBagsError, setUsedBagsError] = useState(false);
    const [usedBagsErrorMsg, setUsedBagsErrorMsg] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        if (activeTab === 'sbproduction') {
            handlePopupSubmit(event);
        } else {
            handleAddSubmit(event);
        }
    };


    const keyFieldsConfig = {
        sets: 'SKU',
        brands: 'brandID',
        containers: 'containerID',
        seeds: 'seedsID',
        setscomposition: ['setSKU', 'sbSKU'],
        seedscategory: 'categoryID',
        employees: 'employeeID',
        emplphones: 'employeeID',
        empladdresses: 'employeeID',
        individualpackets: 'SKU',
        sbproduction: ['sku', 'emplID', 'prodDate', 'shift'],
        mbproduction: ['sku', 'emplID', 'prodDate', 'boxnum'],
        whlocations: 'location',
        seedslocationwh: ['seedsID', 'bagnumid'],
        masterbagsinventory: 'sku',
        smallbagsinventory: 'sku',
        individualpacketsinventory: 'SKU',
        setsinventory: 'SKU',
        wildmicr: 'SKU',
        wildmicrinventory: 'SKU',
        wildmicrmasterbagsinventory: 'sku',
        minitoolsinventory: 'brandID',
        silicagelinventory: 'brandID',
        shipmentsfbamb: ['brandID', 'shipmentID', 'SKU', 'shipmentDate'],
        shipmentsfbafb: ['brandID', 'shipmentID', 'SKU', 'shipmentDate'],
        shipmentssbss: ['brandID', 'SKU', 'shipmentDate'],
        shipmentsssmb: ['brandID', 'SKU', 'shipmentDate'],
        shipmentswildmicrss: ['brandID', 'SKU', 'shipmentDate'],
        shipmentswildmicrfba: ['brandID', 'shipmentID', 'SKU', 'shipmentDate'],
        workperformance: ['employeeID', 'workday', 'shift'],
        materialsuppliers: ['supplierID'],
        seedssuppliers: ['supplierID'],
        smallbagsorder: ['sku', 'orderDate'],
        masterbagsorder: ['sku', 'orderDate'],
        seedsorders: ['seedsID', 'supplierID', 'orderdate'],
        silicabagsorders: ['brandID', 'orderDate'],
        toolsorders: ['brandID', 'orderDate'],
        wmmasterbagsorder: ['sku', 'orderDate'],
        smallbagsinventory_log: ['logID'],
        prodwm: 'recID',
        wildmicrProduction: 'recID',
    };


    const fetchGPerPacketBySKU = async (sku) => {
        try {
            const response = await api.get(`/api/packets/${sku}`);
            if (response.data) {
                const gperpacket = response.data.gperpacket || 0;
                const currentWeight = response.data.currentWeight || 0;
                const lot = response.data.lot || 0;
                setGPerPacket(gperpacket);
                setSeedsstock(currentWeight);
                setSeedslot(lot);
            } else {
                setGPerPacket(0);
                setSeedsstock(0);
                setSeedslot(0);
            }
        } catch (error) {
            setGPerPacket(0);
            setSeedsstock(0);
            setSeedslot(0);
        }
    };

    useEffect(() => {
        const qtyField = popupFields.find(field => field.name === 'qty');
        if (qtyField && gPerPacket > 0 && qtyField.value > 0) {
            const seedsNeeded = gPerPacket * qtyField.value * 0.00220462;
            setApproxSeedsNeeded(seedsNeeded.toFixed(2));
        } else {
            setApproxSeedsNeeded('0');
        }
    }, [gPerPacket, popupFields]);

    const handleSearch = (searchTerm) => {
        setSearchTerm(searchTerm);
    };

    const handleFilter = (params) => {
        setFilterParams(params);
        fetchTabData(`${API_URL}/api/${activeTab}`, params);
    };

    const resetFilters = () => {
        const defaultFilters = {};
        for (const tab in filtersConfig) {
            filtersConfig[tab].forEach(filter => {
                if (filter.defaultValue) {
                    defaultFilters[filter.field] = filter.defaultValue;
                }
            });
        }
        setFilterParams(defaultFilters);
    };

    function formatDateForSQL(date) {
        if (!date) {
            throw new Error("Дата отсутствует");
        }

        const delimiters = ['/', '-', '.'];
        let parts = null;

        for (const delimiter of delimiters) {
            if (date.includes(delimiter)) {
                parts = date.split(delimiter);
                break;
            }
        }

        if (!parts || parts.length !== 3) {
            throw new Error("Неверный формат даты. Ожидались форматы: MM/DD/YYYY, DD-MM-YYYY, YYYY.MM.DD и т.д.");
        }

        let [part1, part2, part3] = parts;

        if (part1.length === 4) {
            return `${part1}-${part2.padStart(2, '0')}-${part3.padStart(2, '0')}`;
        } else if (part3.length === 4) {
            const parsedDate = new Date(`${part3}-${part1}-${part2}`);
            if (!isNaN(parsedDate.getTime())) {
                return parsedDate.toISOString().split('T')[0];
            }
        }

        throw new Error("Некорректный формат даты");
    }

    function formatDateWithoutTimezone(value) {
        if (!value) {
            throw new Error("Дата отсутствует");
        }

        if (typeof value === 'string') {
            const possibleFormats = [
                /^\d{2}\.\d{2}\.\d{4}$/,
                /^\d{4}-\d{2}-\d{2}$/,
                /^\d{2}\/\d{2}\/\d{4}$/
            ];

            for (const format of possibleFormats) {
                if (format.test(value)) {
                    const delimiters = ['.', '-', '/'];
                    for (const delimiter of delimiters) {
                        if (value.includes(delimiter)) {
                            const parts = value.split(delimiter);
                            if (parts.length === 3) {
                                if (format === possibleFormats[0]) {
                                    return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
                                } else if (format === possibleFormats[1]) {
                                    return value;
                                } else if (format === possibleFormats[2]) {
                                    return `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
                                }
                            }
                        }
                    }
                }
            }
        }

        const d = new Date(value);
        if (isNaN(d.getTime())) {
            throw new Error("Некорректный формат даты");
        }

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const fetchBagDetails = async (sku, emplID, prodDate, shift) => {
        try {
            const formattedProdDate = formatDateWithoutTimezone(prodDate);
            const response = await api.get(`/api/sbproduction/details`, {
                params: { sku, emplID, prodDate: formattedProdDate, shift }
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching bag details:", error);
            return null;
        }
    };

    const handleEditOther = (data, id) => {
        const tableName = activeTab;
        const fields = tabs.find(tab => tab.name === tableName).fields.map(field => ({
            ...field,
            value: data[field.name] || '',
        }));

        const keyFields = keyFieldsConfig[tableName];
        const initialKeyValues = Array.isArray(keyFields) ? keyFields.reduce((acc, key) => {
            acc[key] = data[key];
            return acc;
        }, {}) : { [keyFields]: data[keyFields] };

        setPopupData({ ...data, tableName, id, initialKeyValues });
        setPopupFields(fields);
        setPopupTitle(`Edit ${tableName}`);
        setPopupSubtitle(`Edit ${tableName} details`);
        setIsPopupOpen(true);
    };

    const handleEdit = async (data, id) => {
        if (activeTab === 'kitProduction') {
            try {
                const response = await api.get(`/api/kits-production/${data.recID}`);
                setKitPopupData(response.data);
                setIsKitPopupOpen(true);
            } catch (error) {
                console.error('Error fetching kit production details:', error);
            }
        } else if (activeTab === 'fertilizerProduction') {
            try {
                const response = await api.get(`/api/prod-fert/${data.recID}`);
                setFertPopupData(response.data);
                setIsFertPopupOpen(true);
            } catch (error) {
                console.error('Error fetching fert production details:', error);
            }
        } else if (activeTab === 'wildmicrProduction') {
            try {
                const response = await api.get(`/api/prodwm/${data.recID}`);
                const serverData = response.data;

                const transformedData = {
                    recID: serverData.recID || '',
                    GTIN: serverData.GTIN || '',
                    plannedQty: serverData.qty_to_produce || '',
                    bagsTaken: serverData.bagsTaken || [],
                    allBoxes: serverData.allBoxes || [],
                    lbUsed: serverData.lbUsed || 0,
                    returnSeeds: serverData.returnSeeds || null,
                    productionLog: serverData.productionLog?.map(day => ({
                        employee: day.emplID || '',
                        date: day.date || '',
                        emplID: day.emplID || '',
                        startTime: day.start_time || '',
                        endTime: day.end_time || '',
                        qtyProduced: day.qty_produced || 0,
                        boxes: day.boxes || []
                    })) || [],
                    completeProduction: serverData.status === 'Complete' || false,
                    extraNoBoxPacks: serverData.extra_no_box || '',
                    extraEmployees: serverData.extraEmployees || [],
                };

                setWMPopupData(transformedData);
                setIsWMPopupOpen(true);
            } catch (error) {
                console.error('Error fetching production details:', error);
            }
        } else if (activeTab === 'sbproduction') {
            const timeZone = 'America/New_York';
            // Тип операции приходит в строке списка (sbproduction.product_type)
            setProductType(data.product_type || 'seeds');
            const bagDetails = await fetchBagDetails(data.sku, data.emplID, data.prodDate, data.shift);
            if (!bagDetails) {
                console.error("Не удалось получить детали мешков.");
                return;
            }
            // Преобразуем данные о взятых мешках в формат для таблицы
            // const usedBags = await fetchUsedBagsByRecID(data.recID);
            // setUsedBagsData(usedBags);

            setIsAddMode(false);
            const currentDate = format(toZonedTime(new Date(), timeZone), 'yyyy-MM-dd');
            const currentTime = format(toZonedTime(new Date(), timeZone), 'HH:mm');
            const currentTab = tabs.find(tab => tab.name === activeTab);
            if (!currentTab) {
                console.error(`Active tab ${activeTab} не найден`);
                return;
            }
            const tookLabel = `${data.product_type === 'fert' ? 'Fertilizer' : 'Seeds'} Took LB`;
            const fields = currentTab.fields.map(field => {
                const fieldValue = data[field.name];
                switch (field.name) {
                    case 'prodDate':
                        return { ...field, value: fieldValue ? toLocalDateString(fieldValue) : '' };
                    case 'startTime':
                        return { ...field, value: fieldValue || '' };
                    case 'endTime':
                        return { ...field, value: fieldValue || currentTime };
                    case 'seedstook':
                        return { ...field, value: fieldValue || '', label: tookLabel };
                    default:
                        return { ...field, value: fieldValue || '' };
                }
            });
            const startTimeField = fields.find(field => field.name === 'startTime');
            const endTimeField = fields.find(field => field.name === 'endTime');
            if (startTimeField?.value && !endTimeField?.value) {
                setPopupFields(fields);
                setSecondPopupFields([]);
                setPopupData({ ...data, tableName: activeTab, id });
                setPopupTitle(`Edit ${activeTab}`);
                setPopupSubtitle(`Edit ${activeTab} details`);
                setIsPopupOpen(true);

                // Инициализируем проверку Used Bags через небольшой таймаут
                setTimeout(() => {
                // Если условия Complete выполнены, проверяем Used Bags
                if (checkCompleteConditions() && data.recID) {
                    console.log('Initial check: record is ready for Complete, validating Used Bags...');
                    validateUsedBags().then(isValid => {
                    setUsedBagsError(!isValid);
                    });
                }
                }, 100);
                return;
            }
            let secondFields = currentTab.secondFields?.map(field => {
                const fieldValue = data[field.name];
                switch (field.name) {
                    case 'finishdate':
                        return { ...field, value: fieldValue ? toLocalDateString(fieldValue) : '' };
                    case 'starttimes':
                        return { ...field, value: fieldValue || '' };
                    case 'endtimes':
                        return { ...field, value: fieldValue || '' };
                    default:
                        return { ...field, value: fieldValue || '' };
                }
            }) || [];

            // ДОБАВЛЯЕМ ТАБЛИЦУ USED BAGS КАК ПОЛЕ В secondFields СРАЗУ ПОСЛЕ EMPLOYEE
            if (data.recID) {
                const usedBagsIndex = secondFields.findIndex(field => field.name === 'employeefinish');
                
                if (usedBagsIndex !== -1) {
                    const usedBagsField = {
                        label: '',
                        name: 'usedBagsTable',
                        type: 'custom',
                        value: (
                            <EditableUsedBagsTable
                            recID={data.recID}
                            sku={data.sku}
                            API_URL={API_URL}
                            readOnly={false}
                            highlightErrors={usedBagsError}
                            onBagsUpdated={handleUsedBagsUpdate} // Передаем функцию для обновления
                            />
                        ),
                        };
                                        
                    // Вставляем таблицу после поля employeefinish
                    secondFields.splice(usedBagsIndex + 1, 0, usedBagsField);
                }
            }

            const takenBags = [];
            if (bagDetails.bagnum1) takenBags.push(`Bag ${bagDetails.bagnum1}, Weight: ${bagDetails.takenWeight1 || 0} LB`);
            if (bagDetails.bagnum2) takenBags.push(`Bag ${bagDetails.bagnum2}, Weight: ${bagDetails.takenWeight2 || 0} LB`);
            if (bagDetails.bagnum3) takenBags.push(`Bag ${bagDetails.bagnum3}, Weight: ${bagDetails.takenWeight3 || 0} LB`);
            if (bagDetails.bagnum4) takenBags.push(`Bag ${bagDetails.bagnum4}, Weight: ${bagDetails.takenWeight4 || 0} LB`);
            if (bagDetails.bagnum5) takenBags.push(`Bag ${bagDetails.bagnum5}, Weight: ${bagDetails.takenWeight5 || 0} LB`);
            if (bagDetails.bagnum6) takenBags.push(`Bag ${bagDetails.bagnum6}, Weight: ${bagDetails.takenWeight6 || 0} LB`);
            if (bagDetails.bagnum7) takenBags.push(`Bag ${bagDetails.bagnum7}, Weight: ${bagDetails.takenWeight7 || 0} LB`);
            if (bagDetails.bagnum8) takenBags.push(`Bag ${bagDetails.bagnum8}, Weight: ${bagDetails.takenWeight8 || 0} LB`);
            const takenBagsField = {
                label: '',
                name: 'takenBags',
                type: 'custom',
                value: (
                    <div>
                        <p>{takenBags.length > 0 ? takenBags.join(', ') : 'No bags taken'}</p>
                    </div>
                ),
            };
            const index = fields.findIndex(field => field.name === 'seedstook');
            const fieldsWithTakenBags = [
                ...fields.slice(0, index + 1),
                takenBagsField,
                ...fields.slice(index + 1),
            ];
            
            setPopupFields(fieldsWithTakenBags);
            setSecondPopupFields(secondFields);
            setPopupData({ ...data, tableName: activeTab, id });
            setPopupTitle(`Edit ${activeTab}`);
            setPopupSubtitle(`Edit ${activeTab} details`);
            setIsPopupOpen(true);
            // Проверяем валидность Used Bags при открытии попапа редактирования
            setTimeout(() => {
            checkIfReadyForComplete();
            }, 500);
        } else {
            handleEditOther(data, id);
        }
    };

   

    
    const safeFormatTime = (value) => {
        if (value && typeof value === 'string' && !isNaN(Date.parse(value))) {
            const date = new Date(value);
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${hours}:${minutes}`;
        }
        return '';
    };

    const safeFormatDate = (value) => {
        if (!value || typeof value !== 'string') return '';

        const delimiters = ['-', '/', '.', ' '];
        let parts;

        for (const delimiter of delimiters) {
            if (value.includes(delimiter)) {
                parts = value.split(delimiter);
                break;
            }
        }

        if (!parts || parts.length !== 3) return '';

        let year, month, day;

        if (parts[0].length === 4) {
            [year, month, day] = parts;
        } else if (parts[2].length === 4) {
            [month, day, year] = parts;
        } else {
            return '';
        }

        return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    };



    const handleClosePopup = () => {
  setPopupFields([]);
  setSecondPopupFields([]);
  setPopupData(null);
  setIsPopupOpen(false);
  setUsedBagsError(false);
  setUsedBagsErrorMsg('');
};

    const handleAddFromPlanned = async (rowData) => {
  try {
    const response = await api.get(`/api/get-gtin-by-sku/${rowData.sku}`);
    const gtin = response.data.GTIN;
    if (!gtin) {
      alert('GTIN not found for this SKU');
      return;
    }
    const timeZone = 'America/New_York';
    const now = new Date();
    const miamiTime = toZonedTime(now, timeZone);
    const formattedDate = format(miamiTime, 'yyyy-MM-dd');
    const currentTime = format(miamiTime, 'HH:mm');

    const currentTab = tabs.find(tab => tab.name === 'sbproduction');
    const fields = currentTab.fields.map(field => {
      if (field.name === 'GTIN') {
        return { ...field, value: gtin };
      } else if (field.name === 'qty') {
        return { ...field, value: rowData.qty };
      } else if (field.name === 'prodDate') {
        return { ...field, value: rowData.prodDate || formattedDate };
      } else if (field.name === 'startTime') {
        return { ...field, value: currentTime };
      } else {
        return { ...field, value: '' };
      }
    });

    setPopupFields(fields);
    setSecondPopupFields(currentTab.secondFields?.map(field => ({ ...field, value: '' })) || []);
    setPopupData({
      tableName: 'sbproduction',
      qty: rowData.qty,
      prodDate: rowData.prodDate,
      planned_production_id: rowData.id, // Передаем id из sbplanned_production
      // План поставлен с заменой семян: показываем это в Check Seeds и в попапе операции
      plannedSubstitute: rowData.use_substitute ? (rowData.substituteNames || 'substitute seeds') : ''
    });
    setSelectedGTIN(gtin);
    setIsConfirmPopupOpen(true);
    setIsAddMode(true);
  } catch (error) {
    console.error('Error fetching GTIN:', error);
    alert('Error fetching GTIN');
  }
};

const handlePopupSubmit = async (event) => {
  event.preventDefault();
  
  // Проверка условий для статуса Complete
  const isCompleteStatus = checkCompleteConditions();
  
  console.log('Checking Complete conditions:', {
    isCompleteStatus,
    popupData,
    sameday: secondPopupFields.find(f => f.name === 'sameday')?.value,
    prodDate: popupFields.find(f => f.name === 'prodDate')?.value,
    startTime: popupFields.find(f => f.name === 'startTime')?.value,
    endTime: popupFields.find(f => f.name === 'endTime')?.value
  });
  
  // Если запись завершается (статус Complete), проверяем таблицу Used Bags
  if (isCompleteStatus) {
    console.log('Record will be Complete, validating Used Bags...');
    
    // Проверяем валидность таблицы Used Bags
    const isValid = await validateUsedBags();
    
    console.log('Used Bags validation result:', isValid);
    
    if (!isValid) {
      // Устанавливаем ошибку и прерываем отправку
      setUsedBagsError(true);
      // Не закрываем попап, остаемся в нем для исправления
      return;
    }
  } else {
    console.log('Record will NOT be Complete (status stays In Progress or other)');
  }
  
  // Если валидация прошла или статус не Complete, сбрасываем ошибку
  setUsedBagsError(false);
  
  // Продолжаем обработку как раньше
  const updateData = popupFields.reduce((acc, field) => {
    if (['gperpacket', 'box_size', 'approxSeedsNeeded', 'seedsstock', 'seedslot', 'day', 'plannedSubstitute'].includes(field.name)) {
      return acc;
    }
    if (field.type === 'date' && field.value) {
      acc[field.name] = formatDateForSQL(field.value);
    } else {
      acc[field.name] = field.value;
    }
    return acc;
  }, {});

  if (secondPopupFields.length > 0) {
    secondPopupFields.forEach(field => {
      if (field.type === 'date' && field.value) {
        updateData[field.name] = formatDateForSQL(field.value);
      } else if (field.type === 'checkbox') {
        updateData[field.name] = field.value === 1 ? 1 : 0;
      } else {
        updateData[field.name] = field.value;
      }
    });
  }

  updateData.planned_production_id = popupData.planned_production_id || null;

  try {
    const url = `/api/sbproduction`;
    const method = popupData.id ? 'put' : 'post';

    await api({
      method,
      url,
      data: updateData
    });

    handleClosePopup();
    setUpdateKey(prevKey => prevKey + 1);
  } catch (error) {
    console.error('Error during processing:', error);
    alert(error.response?.data?.error || 'An unexpected error occurred');
  }
};

// Функция проверки условий для статуса Complete
const checkCompleteConditions = () => {
  console.log('checkCompleteConditions called');
  
  // Находим поле sameday
  const samedayField = secondPopupFields.find(field => field.name === 'sameday');
  const isSameDay = samedayField ? samedayField.value === 1 : false;
  
  console.log('samedayField:', samedayField);
  console.log('isSameDay:', isSameDay);
  
  // Проверяем поля первого дня
  const prodDateField = popupFields.find(field => field.name === 'prodDate');
  const startTimeField = popupFields.find(field => field.name === 'startTime');
  const endTimeField = popupFields.find(field => field.name === 'endTime');
  
  const isFirstDayComplete = prodDateField?.value && 
                            startTimeField?.value && 
                            endTimeField?.value;
  
  console.log('First day fields:', {
    prodDate: prodDateField?.value,
    startTime: startTimeField?.value,
    endTime: endTimeField?.value,
    isFirstDayComplete
  });
  
  if (isSameDay) {
    // Если галочка Same day production стоит, достаточно заполнения первого дня
    console.log('Same day production, checking first day only');
    return isFirstDayComplete;
  } else {
    // Если галочка не стоит, проверяем второй день
    const finishDateField = secondPopupFields.find(field => field.name === 'finishdate');
    const startTimesField = secondPopupFields.find(field => field.name === 'starttimes');
    const endTimesField = secondPopupFields.find(field => field.name === 'endtimes');
    
    const isSecondDayComplete = finishDateField?.value && 
                               startTimesField?.value && 
                               endTimesField?.value;
    
    console.log('Second day fields:', {
      finishDate: finishDateField?.value,
      startTimes: startTimesField?.value,
      endTimes: endTimesField?.value,
      isSecondDayComplete
    });
    
    const result = isFirstDayComplete && isSecondDayComplete;
    console.log('Both days required, result:', result);
    return result;
  }
};

// Функция для проверки, готова ли форма к Complete
const checkIfReadyForComplete = () => {
  const isCompleteStatus = checkCompleteConditions();
  
  if (isCompleteStatus && popupData?.recID) {
    // Если условия Complete выполнены, проверяем Used Bags
    validateUsedBags().then(isValid => {
      setUsedBagsError(!isValid);
    });
  } else {
    setUsedBagsError(false);
  }
};

const handleUsedBagsUpdate = (updatedBags) => {
  console.log('Used Bags updated, revalidating with:', updatedBags);
  const isValid = validateUsedBagsLocal(updatedBags);
  setUsedBagsError(!isValid);
  
  // Если все мешки валидны, явно сбрасываем состояние
  if (isValid) {
    setUsedBagsError(false);
    setUsedBagsErrorMsg('');
  }
};

// Функция валидации таблицы Used Bags
const validateUsedBags = async () => {
  try {
    if (!popupData?.recID) {
      console.log('No record ID, skipping Used Bags validation');
      setUsedBagsErrorMsg('Cannot validate used bags without record ID');
      return false;
    }
    
    console.log('Validating Used Bags for recID:', popupData.recID);
    
    // Загружаем актуальные данные о мешках
    const response = await api.get(
      `/api/sbproduction/${popupData.recID}/used-bags`
    );
    
    const bags = response.data;
    
    console.log('Loaded bags from server:', bags);
    
    if (!bags || bags.length === 0) {
      console.log('No bags found');
      setUsedBagsErrorMsg('No used bags found. Please add used bags information.');
      return false;
    }
    
    // Проверяем каждый мешок
    const invalidBags = [];
    
    bags.forEach(bag => {
      // Проверяем usedWhole (может быть булево или число 0/1)
      const isUsedWhole = bag.usedWhole === true || bag.usedWhole === 1;
      
      // Получаем остаток веса в мешке (weight), а не totalWeight контейнера!
      // weight - это остаток в мешке после использования
      const weightInBag = parseFloat(bag.weight || 0);
      
      console.log(`Bag ${bag.bagNum}: usedWhole=${isUsedWhole}, weightInBag=${weightInBag}, totalWeight=${bag.totalWeight}`);
      
      // Критерий валидности: либо галочка Used Whole стоит, либо остаток веса > 0
      if (!isUsedWhole && weightInBag <= 0) {
        invalidBags.push({
          bag: bag.bagNum,
          seedsName: bag.seedsName || 'Unknown',
          weightInBag: weightInBag,
          usedWhole: isUsedWhole,
          totalWeight: bag.totalWeight
        });
      }
    });
    
    console.log('Invalid bags found:', invalidBags);
    
    if (invalidBags.length > 0) {
      const errorMsg = invalidBags.length === 1 
        ? `Bag ${invalidBags[0].bag} (${invalidBags[0].seedsName}) is not properly filled. Remaining weight in bag: ${invalidBags[0].weightInBag} LB. Please either check "Used Whole" or enter weight > 0 in the Weight column.`
        : `Multiple bags (${invalidBags.length}) are not properly filled. For each bag, please either check "Used Whole" or enter weight > 0 in the Weight column.`;
      
      setUsedBagsErrorMsg(errorMsg);
      return false;
    }
    
    // Все мешки валидны
    console.log('All bags are valid');
    setUsedBagsErrorMsg('');
    return true;
  } catch (error) {
    console.error('Error validating used bags:', error);
    setUsedBagsErrorMsg('Error validating used bags. Please try again.');
    return false;
  }
};

// Функция для локальной валидации Used Bags (без запроса на сервер)
const validateUsedBagsLocal = (bags) => {
  console.log('Validating bags locally:', bags);
  
  if (!bags || bags.length === 0) {
    console.log('No bags found');
    setUsedBagsErrorMsg('No used bags found. Please add used bags information.');
    return false;
  }
  
  const invalidBags = [];
  
  bags.forEach(bag => {
    const isUsedWhole = bag.usedWhole === true || bag.usedWhole === 1;
    const weightInBag = parseFloat(bag.weight || 0);
    
    console.log(`Bag ${bag.bagNum}: usedWhole=${isUsedWhole}, weightInBag=${weightInBag}`);
    
    if (!isUsedWhole && weightInBag <= 0) {
      invalidBags.push({
        bag: bag.bagNum,
        seedsName: bag.seedsName || 'Unknown',
        weightInBag: weightInBag,
        usedWhole: isUsedWhole
      });
    }
  });
  
  console.log('Invalid bags found:', invalidBags);
  
  if (invalidBags.length > 0) {
    const errorMsg = invalidBags.length === 1 
      ? `Bag ${invalidBags[0].bag} (${invalidBags[0].seedsName}) is not properly filled. Remaining weight in bag: ${invalidBags[0].weightInBag} LB. Please either check "Used Whole" or enter weight > 0 in the Weight column.`
      : `Multiple bags (${invalidBags.length}) are not properly filled. For each bag, please either check "Used Whole" or enter weight > 0 in the Weight column.`;
    
    setUsedBagsErrorMsg(errorMsg);
    return false;
  }
  
  console.log('All bags are valid');
  setUsedBagsErrorMsg('');
  return true;
};





    const handleFirstFormFieldChange = (index, event) => {
        const { value, type } = event.target;
        const newFields = [...popupFields];

        if (type === 'date') {
            newFields[index].value = value;
        } else {
            newFields[index].value = value !== null ? value : '';
        }

        if (newFields[index].name === 'GTIN' && isAddMode) {
            if (activeTab === 'sbproduction') {
                setIsConfirmPopupOpen(true);
                setSelectedGTIN(value);
            }
        }

        if (activeTab === 'sbproduction') {
            if (newFields[index].name === 'GTIN') {
                const selectedGTIN = value;

                api.get(`/api/packets/gtin/${selectedGTIN}`)
                    .then(response => {
                        const { gperpacket, currentWeight, lot, box_size, product_type } = response.data;

                        setProductType(product_type || 'seeds');
                        setGPerPacket(gperpacket);
                        setSeedsstock(currentWeight);
                        setSeedslot(lot);

                        newFields.find(field => field.name === 'gperpacket').value = gperpacket;
                        const boxField = newFields.find(field => field.name === 'box_size');
                        if (boxField) boxField.value = box_size || '';
                        newFields.find(field => field.name === 'seedsstock').value = currentWeight;
                        newFields.find(field => field.name === 'seedslot').value = lot;

                        const qtyField = newFields.find(field => field.name === 'qty');
                        if (gperpacket > 0 && qtyField && qtyField.value > 0) {
                            const seedsNeeded = gperpacket * qtyField.value * 0.00220462;
                            setApproxSeedsNeeded(seedsNeeded.toFixed(2));
                            newFields.find(field => field.name === 'approxSeedsNeeded').value = seedsNeeded.toFixed(2);
                        }
                    })
                    .catch(() => {
                        setGPerPacket(0);
                        setSeedsstock(0);
                        setSeedslot(0);
                        setApproxSeedsNeeded('N/A');
                    });
            }

            if (newFields[index].name === 'qty') {
                const qty = value;
                if (gPerPacket > 0 && qty > 0) {
                    const seedsNeeded = gPerPacket * qty * 0.00220462;
                    setApproxSeedsNeeded(seedsNeeded.toFixed(2));
                    newFields.find(field => field.name === 'approxSeedsNeeded').value = seedsNeeded.toFixed(2);
                } else {
                    setApproxSeedsNeeded('0');
                }
            }
        }
        // После обновления полей проверяем готовность к Complete
        checkIfReadyForComplete();
        setPopupFields(newFields);
        setPopupData({ ...popupData, [newFields[index].name]: value });
    };

    useEffect(() => {
        const qtyField = popupFields.find(field => field.name === 'qty');
        if (qtyField && gPerPacket > 0 && qtyField.value > 0) {
            const seedsNeeded = gPerPacket * qtyField.value * 0.00220462;
            setApproxSeedsNeeded(seedsNeeded.toFixed(2));
        } else {
            setApproxSeedsNeeded('0');
        }
    }, [gPerPacket, popupFields]);

    const handleConfirmSeeds = (isCorrect, bagData, qtyToProduce, productInfo) => {
        if (isCorrect) {
            if (productInfo?.productType) setProductType(productInfo.productType);
            const totalWeight = bagData.reduce((sum, bag) => sum + parseFloat(bag.weight || 0), 0);
            // Подпись поля скопирована из tabs до ответа по GTIN: переименовываем по типу продукта
            const tookLabel = `${productInfo?.productType === 'fert' ? 'Fertilizer' : 'Seeds'} Took LB`;

            const updatedFields = popupFields.map(field =>
                field.name === 'seedstook' ? { ...field, value: totalWeight, label: tookLabel } :
                field.name === 'qty' ? { ...field, value: qtyToProduce } :
                field
            );

            const updatedBags = bagData.map((bag, index) => ({
                index,
                bagnumID: bag.bagnumID,
                lot: bag.lot || 'Unknown',
                returnedWeight: 0,
                returnLot: ''
            }));

            setBagsTakenForProduction(updatedBags);

            const takenBagsField = {
                label: '',
                name: 'takenBags',
                type: 'label',
                value: bagData.map(bag => `Bag ${bag.bagnumID}, Weight: ${bag.weight} LB`).join(', '),
            };

            const plannedSubstituteField = popupData?.plannedSubstitute ? [{
                label: <><i className="fa-solid fa-right-left" style={{ marginRight: 6 }}></i>Planned with substitute seeds - </>,
                name: 'plannedSubstitute',
                type: 'label',
                value: popupData.plannedSubstitute,
                className: 'gperpacket-label dynamic-label',
            }] : [];

            const index = updatedFields.findIndex(field => field.name === 'seedstook');
            const fieldsWithTakenBags = [
                ...updatedFields.slice(0, index + 1),
                takenBagsField,
                ...plannedSubstituteField,
                ...updatedFields.slice(index + 1),
            ];

            setPopupFields(fieldsWithTakenBags);
            setIsConfirmPopupOpen(false);

            setIsPopupOpen(true);
            setPopupTitle('Add New sbproduction');
            setPopupSubtitle('Add new sbproduction details');
        }
    };

    const handleCloseConfirmPopup = () => {
        if (isAddMode) {
            const newFields = popupFields.map((field) =>
                field.name === 'GTIN' ? { ...field, value: '' } : field
            );
            setPopupFields(newFields);
        }
        setIsConfirmPopupOpen(false);
    };

    const handleSecondFormFieldChange = async (index, event) => {
        const { value, name, type, checked } = event.target;
        const newFields = [...secondPopupFields];
        if (type === 'checkbox') {
            newFields[index].value = checked ? 1 : 0;
        } else {
            newFields[index].value = value;
        }


        setSecondPopupFields(newFields);
        setPopupData({ ...popupData, [newFields[index].name]: value });

        // После обновления полей проверяем готовность к Complete
        checkIfReadyForComplete();
    };

    const handleAddClick = async () => {
        if (activeTab === 'kitProduction') {
            setKitPopupData(null);
            setIsKitPopupOpen(true);
        } else if (activeTab === 'mbproduction') {
            setIsSetsPopupOpen(true);
        } else if (activeTab === 'fertilizerProduction') {
            setFertPopupData(null);
            setIsFertPopupOpen(true);
        } else if (activeTab === 'wildmicrProduction') {
            setWMPopupData(null);
            setIsWMPopupOpen(true);
        } else if (activeTab === 'sbproduction') {
            try {
                const response = await api.get(`/api/sbproduction/count-in-progress`);
                const count = response.data.count;
                if (count >= 4) {
                    alert('You need to complete the existing records before adding a new one.');
                    return;
                }
                setIsAddMode(true);
                const timeZone = 'America/New_York';
                const now = new Date();
                const miamiTime = toZonedTime(now, timeZone);
                const formattedDate = format(miamiTime, 'yyyy-MM-dd');
                const currentTime = format(miamiTime, 'HH:mm');
                const currentTab = tabs.find((tab) => tab.name === activeTab);
                if (!currentTab) {
                    console.error(`Tab not found for activeTab: ${activeTab}`);
                    return;
                }
                const fields = currentTab.fields.map((field) => ({
                    ...field,
                    value: field.name === 'prodDate' ? formattedDate : field.name === 'startTime' ? currentTime : '',
                }));
                const secondFields = currentTab.secondFields?.map((field) => ({
                    ...field,
                    value: '',
                })) || [];
                setPopupData({ tableName: activeTab });
                setPopupFields(fields);
                setSecondPopupFields(secondFields);
                setPopupTitle(`Add New ${activeTab}`);
                setPopupSubtitle(`Add new ${activeTab} details`);
                setIsPopupOpen(true);
            } catch (error) {
                console.error('Error checking In Progress records:', error);
                alert('An error occurred while checking records.');
            }
        } else {
            setIsAddMode(true);
            const timeZone = 'America/New_York';
            const now = new Date();
            const miamiTime = toZonedTime(now, timeZone);
            const formattedDate = format(miamiTime, 'yyyy-MM-dd');
            const currentTime = format(miamiTime, 'HH:mm');
            const currentTab = tabs.find((tab) => tab.name === activeTab);
            if (!currentTab) {
                console.error(`Tab not found for activeTab: ${activeTab}`);
                return;
            }
            const fields = currentTab.fields.map((field) => ({
                ...field,
                value: field.name === 'prodDate' ? formattedDate : field.name === 'startTime' ? currentTime : '',
            }));
            const secondFields = currentTab.secondFields?.map((field) => ({
                ...field,
                value: '',
            })) || [];
            setPopupData({ tableName: activeTab });
            setPopupFields(fields);
            setSecondPopupFields(secondFields);
            setPopupTitle(`Add New ${activeTab}`);
            setPopupSubtitle(`Add new ${activeTab} details`);
            setIsPopupOpen(true);
        }
    };

    const handleAddSubmit = async (event) => {
        event.preventDefault();

        try {
            const newData = popupFields.reduce((acc, field) => {
                acc[field.name] = field.value;
                return acc;
            }, {});

            const tableName = popupData.tableName;
            const keyFields = keyFieldsConfig[tableName];
            const isEditMode = !!popupData.id;

            let url;
            let method;

            if (isEditMode) {
                const currentKeys = popupData.initialKeyValues;
                if (Array.isArray(keyFields)) {
                    const id = keyFields.map(key => `${key}=${currentKeys[key]}`).join('&');
                    url = `/api/${tableName}?${id}`;
                } else {
                    const id = currentKeys[keyFields];
                    url = `/api/${tableName}/${id}`;
                }
                method = 'put';
            } else {
                url = `/api/${tableName}`;
                method = 'post';
            }

            await api({
                method,
                url,
                data: newData,
            });

            handleClosePopup();
            setUpdateKey((prevKey) => prevKey + 1);
        } catch (error) {
            console.error('Error adding/updating data:', error);
            if (error.response) {
                alert(error.response.data.error || 'An unexpected error occurred');
            }
        }
    };

function calculateHoursTook(row) {
  const { startTime, endTime, starttimes, endtimes } = row;

  function timeToMinutes(t) {
    if (!t || t === '00:00:00') return null;
    const parts = t.split(':').map(Number);
    const h = parts[0] || 0;
    const m = parts[1] || 0;
    const s = parts[2] || 0;
    return h * 60 + m + s / 60;
  }

  function minutesToHours(m) {
    return m > 0 ? Math.round((m / 60) * 100) / 100 : 0;
  }

  const shiftStart = timeToMinutes('08:00:00'); // 480
  const shiftEnd = timeToMinutes('23:00:00');   // 1380

  function calculateSegment(start, end) {
    if (!start || !end || end === '00:00:00') return 0;

    const startMin = timeToMinutes(start);
    const endMin = timeToMinutes(end);

    if (startMin === null || endMin === null) return 0;

    const clampedStart = Math.max(startMin, shiftStart);
    const clampedEnd = Math.min(endMin, shiftEnd);

    let minutes;
    if (endMin >= startMin) {
      minutes = Math.max(0, clampedEnd - clampedStart);
    } else {
      // Переход через день
      const minutesDay1 = Math.max(0, shiftEnd - clampedStart);
      const minutesDay2 = Math.max(0, clampedEnd - shiftStart);
      minutes = minutesDay1 + minutesDay2;
    }
    return minutesToHours(minutes);
  }

  const segment1 = calculateSegment(startTime, endTime);
  const segment2 = (starttimes && endtimes) ? calculateSegment(starttimes, endtimes) : 0;

  return (segment1 + segment2).toFixed(2);
}

    const fetchTabData = async (endpoint) => {
  try {
    const response = await api.get(endpoint, {
      params: {
        page: 1,
        limit: 100,
        search: searchTerm,
        ...filterParams
      }
    });
    const items = response.data.items.map(item => ({
      ...item,
      hoursTook: calculateHoursTook(item)  // Перезаписываем или добавляем новое поле
    }));
    setData(items);
  } catch (error) {
    console.error('Error fetching tab data:', error);
  }
};
    function formatDateForServer(date) {
        if (!date) {
            throw new Error("Некорректная дата");
        }
        return new Date(date).toISOString().split('T')[0];
    }

    function toLocalDateString(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const tabs = [
        {
            name: 'sbproduction',
            label: 'Small Bags',
            fields: [
                { label: 'Employee', name: 'emplID', type: 'select', tableName: 'employees', displayField: 'fullName', updateField: 'employeeID' },
                { label: 'Scan Barcode with GTIN', name: 'GTIN', type: 'text' },
                { label: 'Grams per Packet - ', name: 'gperpacket', type: 'label', value: gPerPacket, className: 'gperpacket-label dynamic-label' },
                { label: <><i className="fa-solid fa-box" style={{ marginRight: 6 }}></i>Box - </>, name: 'box_size', type: 'label', value: '', hideEmpty: true, className: 'gperpacket-label dynamic-label' },
                { label: 'QTY to Produce', name: 'qty', type: 'text' },
                { label: `${materialWord} Took LB`, name: 'seedstook', type: 'text', readOnly: true },
                { label: 'Machine Number', name: 'machinenumber', type: 'text' },
                { label: 'Day 1', name: 'day', type: 'label', value: '', className: 'daynum-label' },
                { label: 'Date', name: 'prodDate', type: 'date' },
                { label: 'Start Time', name: 'startTime', type: 'time' },
                { label: 'Finish Time', name: 'endTime', type: 'time' },
            ],
            secondFields: [
                { label: 'Employee', name: 'employeefinish', type: 'select', tableName: 'employees', displayField: 'fullName', updateField: 'employeeID' },

                
                { label: 'Damage Packets', name: 'damage', type: 'text' },
                { label: 'Same Day Finish', name: 'sameday', type: 'checkbox', className: 'row' },
                { label: 'Day 2', name: 'day', type: 'label', value: '', className: 'daynum-label' },
                { label: 'Finish Date', name: 'finishdate', type: 'date' },
                { label: 'Start Time', name: 'starttimes', type: 'time' },
                { label: 'Finish Time', name: 'endtimes', type: 'time' },
            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'ID', key: 'recID' },
                        { label: 'SKU', key: 'sku' },
                        { label: 'Name', key: 'packName' },
                        { label: 'Employees', key: 'employees' },
                        { label: 'Start Date', key: 'prodDate', type: 'date' },
                        { label: 'Finish Date', key: 'finishdate', type: 'date' },
                        { label: 'QTY', key: 'qty' },
                        { label: 'Took LB', key: 'seedstook' },
                        { label: 'Needed LB', key: 'plannedlb' },
                        { label: 'Used LB', key: 'usedSeeds' },
                        { label: 'Back LB', key: 'seedsback' },
                        { label: 'Time Spend', key: 'hoursTook' },
                        { label: 'Damage', key: 'damage' },
                    ]}
                    endpoint={`${API_URL}/api/sbproduction`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data, id) => {
                        if (activeTab === 'sbproduction') {
                            handleEdit(data, id);
                        } else {
                            handleEditOther(data, id);
                        }
                    }}
                    onAddFromPlanned={handleAddFromPlanned}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                    showStatus={true}
                />
            )
        },
        {
            name: 'mbproduction',
            label: 'Sets Production',
            fields: [
                { label: 'Employee', name: 'emplID', type: 'select', tableName: 'employees', displayField: 'fullName', updateField: 'employeeID' },
                { label: 'Add sets from scanner', name: 'scanneddata', type: 'text' },
            ],
            content: (
                <DataTableWithExpandableRows
                    columns={[
                        { key: 'sku', label: 'SKU' },
                        { key: 'setmane', label: 'Set' },
                        { key: 'box_count', label: 'Boxes QTY' },
                        { key: 'total_qty', label: 'Sets QTY' },
                        { key: 'last_added_date', label: 'Last Added Date' },
                        { key: 'last_added_by', label: 'Last Added By' },
                    ]}
                    endpoint={`${API_URL}/api/mbproduction`}
                    hasSubGroups={true}
                    subGroupConfig={{
                        endpoint: `${API_URL}/api/mbproduction/dategroups`,
                        queryParamsMapping: {
                            sku: 'sku'
                        },
                        columns: [
                            {
                                key: 'productionDate',
                                label: 'Production Date',
                                format: (value) => {
                                    const date = new Date(value);
                                    return date.toLocaleDateString('en-US');
                                }
                            },
                        ],
                        keyField: 'productionDate'
                    }}
                    secondaryTableConfig={{
                        endpointBase: `${API_URL}/api/mbproductiondetails`,
                        queryParamsMapping: {
                            sku: 'sku',
                            productionDate: 'productionDate'
                        },
                        columns: [
                            { key: 'box', label: 'Box ID' },
                            { key: 'sku', label: 'SKU' },
                            { key: 'setname', label: 'Set' },
                            { key: 'qty', label: 'QTY' },
                            { key: 'prodDate', label: 'Date ' },
                            { key: 'prodTime', label: 'Time ' },
                            { key: 'addedBy', label: 'Added By' },
                        ],
                        enableEdit: false,
                        enableHistory: false,
                        keyFieldsConfig: ['sku', 'box'],
                    }}
                    keyFieldsConfig={['sku', 'box']}
                    onEdit={handleEdit}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                />
            ),
        },

        {
            name: 'wildmicrProduction',
            label: 'Microgreens & Wildflower Bags',
            fields: [],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'ID', key: 'recID' },
                        { label: 'SKU', key: 'SKU' },
                        { label: 'Name', key: 'packName' },
                        { label: 'Employees', key: 'employees' },
                        { label: 'Date Start', key: 'date_start', type: 'date' },
                        { label: 'Date End', key: 'date_end', type: 'date' },
                        { label: 'Seeds Used', key: 'seeds_used' },
                        { label: 'Seeds Took', key: 'seeds_took' },
                        { label: 'Seeds Back', key: 'seeds_back' },
                        { label: 'Boxes List', key: 'boxes_list' },
                        { label: 'Boxes QTY', key: 'boxes_count' },
                        { label: 'Sets QTY', key: 'sets_qty' },
                    ]}
                    endpoint={`${API_URL}/api/prodwm`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={handleEdit}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                    showStatus={true}
                />
            )
        },

        {
            name: 'fertilizerProduction',
            label: 'Fertilizers',
            fields: [],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'ID',        key: 'recID' },
                        { label: 'SKU',       key: 'SKU' },
                        { label: 'Product',   key: 'productName' },
                        { label: 'Employee',  key: 'employeeName' },
                        { label: 'Date',      key: 'prodDate', type: 'date' },
                        { label: 'Bags',      key: 'bags_count' },
                        { label: 'Boxes',     key: 'boxes_count' },
                        { label: 'Packs QTY', key: 'boxes_qty' },
                    ]}
                    endpoint={`${API_URL}/api/prod-fert`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={handleEdit}
                    keyFieldsConfig={['recID']}
                    showStatus={true}
                />
            ),
        },
        {
            name: 'kitProduction',
            label: 'Kits',
            fields: [],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'ID',       key: 'recID' },
                        { label: 'SKU',      key: 'SKU' },
                        { label: 'Kit',      key: 'productName' },
                        { label: 'Employee', key: 'employeeName' },
                        { label: 'Date',     key: 'prodDate', type: 'date' },
                        { label: 'Boxes',    key: 'boxes_count' },
                        { label: 'Kits QTY', key: 'boxes_qty' },
                    ]}
                    endpoint={`${API_URL}/api/kits-production`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={handleEdit}
                    keyFieldsConfig={['recID']}
                    showStatus={true}
                />
            ),
        },
    ];

    return (
        <>
            <Icons />
            <HeaderLogged />
            <Container>
                <TableTittle
                    sectionTitle="Production"
                    sectionSubtitle="Manage production details"
                    onAddClick={handleAddClick}
                    activeTab={activeTab}
                    tableRefs={tableRefs}
                />
                <SearchAndFilter
                    placeholder="Search by date, employee name, seeds..."
                    onSearch={handleSearch}
                    onFilter={handleFilter}
                    filtersConfig={filtersConfig[activeTab] || []}
                    filterValues={filterParams}
                />
                <Tabs
                    tabs={tabs}
                    activeTab={activeTab}
                    setActiveTab={handleTabChange}
                    tableRefs={tableRefs}
                />
            </Container>
            {popupData && (
                <Popup
                    isOpen={isPopupOpen}
                    onClose={handleClosePopup}
                    title={popupTitle}
                    subtitle={popupSubtitle}
                    fields={popupFields}
                    secondFields={secondPopupFields}
                    onFieldChange={handleFirstFormFieldChange}
                    onSecondFieldChange={handleSecondFormFieldChange}
                    onSubmit={handleSubmit}
                    onSecondSubmit={handlePopupSubmit}
                    submitButtonLabel="Save"
                    secondSubmitButtonLabel="Complete"
                    usedBagsError={usedBagsError}
                    usedBagsErrorMsg={usedBagsErrorMsg}
                />
                )}
            {isWMPopupOpen && (
                <PopupWMProduction
                    isOpen={isWMPopupOpen}
                    onClose={() => setIsWMPopupOpen(false)}
                    mode={wmPopupData ? 'edit' : 'add'}
                    initialData={wmPopupData}
                />
            )}
            {isFertPopupOpen && (
                <PopupFertProduction
                    isOpen={isFertPopupOpen}
                    onClose={() => setIsFertPopupOpen(false)}
                    onSaved={() => setUpdateKey(k => k + 1)}
                    mode={fertPopupData ? 'edit' : 'add'}
                    initialData={fertPopupData}
                />
            )}
            {isSetsPopupOpen && (
                <PopupSetsProduction
                    isOpen={isSetsPopupOpen}
                    onClose={() => setIsSetsPopupOpen(false)}
                    onSaved={() => setUpdateKey(k => k + 1)}
                />
            )}
            {isKitPopupOpen && (
                <PopupKitProduction
                    isOpen={isKitPopupOpen}
                    onClose={() => setIsKitPopupOpen(false)}
                    onSaved={() => setUpdateKey(k => k + 1)}
                    mode={kitPopupData ? 'edit' : 'add'}
                    initialData={kitPopupData}
                />
            )}
            <PopupConfirmSeeds
                isOpen={isConfirmPopupOpen}
                onClose={handleCloseConfirmPopup}
                onConfirm={handleConfirmSeeds}
                selectedGTIN={selectedGTIN}
                initialQty={popupData?.qty || ''}
                plannedSubstitute={popupData?.plannedSubstitute}
            />
        </>
    );
};

export default ProductionPage;